module.exports = __webpack_public_path__ + "img/ssWells_visual_m.097cb0fa.jpg";